import { getIsDarkTheme } from 'mini-theme/lib/selectors/getIsDarkTheme';
import { getPackageBaseUrl } from 'owa-config';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';

export const getIconImageSource = viewProps => {
    const { imageSrc, icon } = viewProps;

    let imageSource: string;
    if (!icon) {
        if (imageSrc) {
            imageSource = imageSrc;
            if (imageSource.includes('resources/')) {
                imageSource = urlResolve(getPackageBaseUrl(), imageSource);
            }
        }
        return imageSource;
    } else {
        return null;
    }
};

export const getCoverImageUrl = viewProps => {
    let { coverImageURL } = viewProps;
    const { darkModeCoverImageURL = '' } = viewProps;

    if (coverImageURL) {
        if (coverImageURL.includes('resources/')) {
            if (!getIsDarkTheme() || darkModeCoverImageURL === '') {
                coverImageURL = urlResolve(getPackageBaseUrl(), coverImageURL);
            } else {
                coverImageURL = urlResolve(getPackageBaseUrl(), darkModeCoverImageURL);
            }
        }
    } else {
        coverImageURL = null;
    }
    return coverImageURL;
};
